export default "__VITE_ASSET__BidAR96p__"